export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_MINUTE_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_SECOND_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_COMPACT_FORMAT = 'YYYYMMDD';
export const TIME_MINUTE_FORMAT = 'HH:mm';

export const DATE_TIME_MINUTE_START_FORMAT = 'YYYY-MM-DD HH:mm:00.000';
export const DATE_TIME_MINUTE_END_FORMAT = 'YYYY-MM-DD HH:mm:59.999';
export const DATE_START_FORMAT = 'YYYY-MM-DD 00:00:00.000';
export const DATE_END_FORMAT = 'YYYY-MM-DD 23:59:59.999';
